import type { Feature, LineString, LineStringFeatureProperties, Position } from "./types"

export const swapLatLng = (coords: Position): [number, number] => [coords[1], coords[0]]

export const isSpeedUnreliable = (geoJsonFeature: Feature<LineString, LineStringFeatureProperties>): boolean =>
  geoJsonFeature.properties.originalSpeed !== undefined &&
  geoJsonFeature.properties.speed !== null &&
  geoJsonFeature.properties.originalSpeed > geoJsonFeature.properties.speed &&
  geoJsonFeature.properties.speed !== geoJsonFeature.properties.speedLimit

export type SpeedMetrics = {
  speedMph: number | null
  speedLimitMph: number | null
  speedExceedancePercentage: number | null
  hasUnreliableSpeed: boolean
  isSpeeding: boolean
}
export const getLineStringSpeedMetrics = (
  geoJsonFeature: Feature<LineString, LineStringFeatureProperties>
): SpeedMetrics => {
  const { speedLimit, speed } = geoJsonFeature.properties
  const speedMph = speed ? kmToMileConverterWithDecimals(speed, 2) : null
  const speedLimitMph = speedLimit ? kmToMileConverterWithDecimals(speedLimit, 2) : null
  const speedExceedancePercentage =
    speedLimitMph && speedMph ? ((speedMph - speedLimitMph) / speedLimitMph) * 100 : null
  const isSpeeding = !!(speedExceedancePercentage && speedExceedancePercentage > 0)
  return {
    speedMph,
    speedLimitMph,
    speedExceedancePercentage,
    hasUnreliableSpeed: isSpeedUnreliable(geoJsonFeature),
    isSpeeding,
  }
}
const KM_TO_MILE = 0.621371
const kmToMileConverterWithDecimals = (distanceInKm: number | undefined, decimals: number = 0): number =>
  distanceInKm ? parseFloat((distanceInKm * KM_TO_MILE).toFixed(decimals)) : 0
